import { moonriver } from '@moonbeam-network/xcm-config';
import { useMoonChainKeyParam } from 'hooks/useMoonChainParam';

interface Tutorials {
  xcm: string;
  staking: string;
  claimRewards: string;
}

export function useTutorials(): Tutorials {
  const moonChainKey = useMoonChainKeyParam();
  const baseUrl = 'https://www.youtube.com/watch?v=';

  return {
    xcm: `${baseUrl}${
      moonChainKey === moonriver.key ? '8RwCyhvpgIU' : 'ueZ1-SOcGi8'
    }`,
    staking: `${baseUrl}${
      moonChainKey === moonriver.key ? '6z7KMK6V168' : 'vHbKJrGd-qs'
    }`,
    claimRewards: `${baseUrl}TEC9ZuTKFZo`,
  };
}
